import { ButtonSpinner } from '../../../helpers/UI/ButtonSpinner/ButtonSpinner';

interface NoPaymentOptionsProps {
  onAddPayment: () => void;
  isLoading?: boolean;
}

const NoPaymentOptions: React.FC<NoPaymentOptionsProps> = ({ onAddPayment, isLoading }) => {
  return (
    <div className='empty-state'>
      <div className='es-ic' style={{ color: '#D1D5DB' }}>
        <svg
          width='48'
          height='48'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
          aria-hidden
        >
          <rect x='1' y='4' width='22' height='16' rx='2' />
          <line x1='1' y1='10' x2='23' y2='10' />
        </svg>
      </div>
      <div className='es-title'>No payment methods yet</div>
      <div className='es-body'>
        Add a payment method to start paying rent through TenantPay and earning tickets and points.
      </div>
      <button type='button' className='btn-blue btn-blue-lg' onClick={onAddPayment}>
        {isLoading && <ButtonSpinner />}
        <span className={isLoading ? 'ml-2' : undefined}>Add payment method</span>
      </button>
    </div>
  );
};

export default NoPaymentOptions;
